/** GA4 property ID – register custom dimensions in Admin using these parameter names. */
export const GA4_MEASUREMENT_ID = 'G-YLFKJT12ZR';

/**
 * Register each row in GA4 Admin → Data display → Custom definitions → Create custom dimension.
 * Scope: Event. Parameter name must match exactly.
 */
export const GA4_CUSTOM_DIMENSIONS = [
  { parameter: 'question_text', description: 'Chat message or typed question' },
  { parameter: 'chat_source', description: 'pill, ask_bar, or follow_up' },
  { parameter: 'message_type', description: 'ai or scripted' },
  { parameter: 'pill_id', description: 'Hero pill identifier' },
  { parameter: 'pill_label', description: 'Hero pill visible label' },
  { parameter: 'follow_up_id', description: 'Chat follow-up identifier' },
  { parameter: 'link_url', description: 'Clicked link URL' },
  { parameter: 'link_text', description: 'Clicked link label' },
  { parameter: 'link_path', description: 'Internal destination path' },
  { parameter: 'link_domain', description: 'Outbound link hostname' },
  { parameter: 'link_type', description: 'mailto, tel, or http' },
  { parameter: 'location', description: 'nav, footer, bento, hero_chat' },
  { parameter: 'cta_name', description: 'email, linkedin, github, resume, external' },
  { parameter: 'project', description: 'Case study slug' },
  { parameter: 'access', description: 'Case study access type' },
];
